import * as actions from '../actions/hotelsActions';

export const initialState = {
    hotelsNew: false,
    hash: '',
    noResults: { value: false, message: '' },
    params: '',
    observations: null,
    query: false,
    filters: {}
};

export default function postsReducer(state = initialState, action) {
    switch (action.type) {
        case actions.SET_HOTELS_NEW:
            return { ...state, hotelsNew: true, hash: action.payload };
        case actions.SET_PARAMS_SEARCH:
            return { ...state, params: action.payload };
        case actions.RESET_HOTELS_NEW:
            return { ...state, hotelsNew: false };
        case actions.NO_RESULTS:
            return { ...state, noResults: { value: true, message: action.payload } };
        case actions.RESULTS:
            return { ...state, noResults: { value: false, message: '' } };
        case actions.SET_OBSERVATIONS:
            return { ...state, observations: action.payload };
        case actions.RESET_OBSERVATIONS:
            return { ...state, observations: null };
        case actions.SET_QUERY: 
            return {...state, query: true};
        case actions.CLEAN_QUERY:
            return {...state, query: false};
        case actions.SET_FILTERS:
            return {...state, filters: {...action.payload}};
        case actions.CLEAN_FILTERS:
            return {...state, filters: {}};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/hotelsReducer.js